import React, { Component } from 'react';
import { Icon, message, Modal, Button, Spin, Row, Select, Tree, Tooltip } from "antd";
import { authData } from "./data";
import { inject, observer } from "mobx-react";
import ExportPdf from "../app/ExportPdf";

const Option = Select.Option;
const TreeNode = Tree.TreeNode;

const authName = [{
    name: "GM/HM 总经理/酒店经理",
    value: "GM"
}, {
    name: "RM/EAM 驻店经理/行政助理经理",
    value: "EAM"
}, {
    name: "DOF 财务总监",
    value: "DOF"
}, {
    name: "FM 财务经理",
    value: "FIN"
}, {
    name: "Income Audit",
    value: "IA"
}, {
    name: "DHR 人力资源总监",
    value: "HR"
}, {
    name: "DOSM 市场营销总监",
    value: "SM"
}, {
    name: "DFB 餐饮总监",
    value: "FB"
}, {
    name: "DOC 宴会统筹总监",
    value: "BQT"
}, {
    name: "DOR 房务总监/EHK 行政管家/FOM 前厅经理",
    value: "Rooms"
}, {
    name: "DOE 工程总监",
    value: "ENG"
}, {
    name: "REVM 收益经理",
    value: "REV"
}, {
    name: "Training",
    value: "Training"
}]

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            data: [],
            visible: false,
            loadingSave: false,
            loading: true,
            hotel: {
                name: "",
                tel: "",
                address: "",
                contacts: ""
            },
            loadingAuth: false,
            authData: [],
            authVisible: false,
            hotelAuthName: "FIN",
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: [],
            selectedKeys: [],
            auth: {},
            authLoading: false,
            dataTotal: []
        }
    }

    componentDidMount() {
        this.props.store.menu.getUserInfo().then(user => {
            this.setState({ user });
        }).catch(err => {
            console.error(err)
        });
    }


    getAuthData = () => {
        fetch('/getBpAuth?user=' + this.state.hotelAuthName, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                let checkedKeys = x.data[0].data.split(',');
                this.setState({
                    auth: x.data[0],
                    checkedKeys,
                    authLoading: false
                });
            } else {
                this.setState({
                    auth: {},
                    checkedKeys: [],
                    authLoading: false
                });
            }

        }).catch(err => {
            console.error(err);
            this.setState({
                authLoading: false
            });
        })
    }

    // 权限
    authshowModal = () => {
        if (this.state.user.email != 'admin') {
            message.error('权限不足！')
            return
        }
        this.setState({
            authVisible: true,
            authLoading: true
        });
        this.getAuthData();

    }
    authhandleOk = (e) => {
        if (this.state.user.email != 'admin') {
            message.error('权限不足！')
            return
        }
        this.setState({ loadingAuth: true });
        let checkedKeys = this.state.checkedKeys;
        let hotelAuthName = this.state.hotelAuthName;
        console.log(checkedKeys)
        let data = {
            ...this.state.auth,
            user: hotelAuthName,
            data: checkedKeys.toString(),
        }

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addBpAuth', headres).then(x => x.json()).then(x => {
            this.setState({ loadingAuth: false });
            if (x.status == 1) {
                message.success('保存成功');
                return
            }

            message.error('保存失败！')
        }).catch(err => {
            console.error(err);
            this.setState({ loadingAuth: false });
        })

    }
    authhandleCancel = (e) => {
        this.setState({
            authVisible: false,
        });
    }

    onChange = (value, lable, extra) => {
        // console.log('onchange', value, lable, extra)
        this.setState({
            selectAuth: value
        });
    }

    onExpand = (expandedKeys) => {
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }
    onCheck = (checkedKeys, checkedNodes) => {
        this.setState({ checkedKeys });
    }
    onSelect = (selectedKeys, info) => {
        this.setState({ selectedKeys });
    }
    renderTreeNodes = (data) => {
        return data.map((item) => {
            if (item.children) {
                return (
                    <TreeNode title={item.title} key={item.key} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode {...item} />;
        });
    }

    render() {
        return (
            <div >
                <div
                    onClick={this.authshowModal}
                    style={{
                        height: "100%",
                        width: "100%"

                    }}
                >
                    <Icon type="setting" style={{ marginRight: 8 }} />
                    权限设置
                </div>
                <Modal
                    title='权限设置'
                    visible={this.state.authVisible}
                    onOk={this.authhandleOk}
                    onCancel={this.authhandleCancel}
                    footer={[
                        <Button key="back" onClick={this.authhandleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingAuth} onClick={this.authhandleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Spin spinning={this.state.authLoading}>
                        <Row className="modal">
                            <Row>
                                <span>选择人员：</span>
                                <Select
                                    value={this.state.hotelAuthName}
                                    style={{ width: 300 }}
                                    onChange={(value) => {
                                        this.setState({
                                            hotelAuthName: value,
                                            authLoading: true,
                                            checkedKeys: []
                                        }, () => {
                                            this.getAuthData()
                                        });
                                    }}
                                >
                                    {authName.map((x, i) => {
                                        return (
                                            <Option key={x.value}>{x.name}</Option>
                                        )
                                    })}
                                </Select>
                            </Row>
                            <Row className="authCotent">
                                <Row>权限配置</Row>
                                <Tree
                                    checkable
                                    // checkStrictly={true}
                                    onExpand={this.onExpand}
                                    expandedKeys={this.state.expandedKeys}
                                    autoExpandParent={this.state.autoExpandParent}
                                    onCheck={this.onCheck}
                                    checkedKeys={this.state.checkedKeys}
                                    onSelect={this.onSelect}
                                    selectedKeys={this.state.selectedKeys}
                                >
                                    {this.renderTreeNodes(authData)}
                                </Tree>
                            </Row>
                        </Row>
                    </Spin>
                </Modal>
            </div >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/bp-views/user/index.js